import React, { useState, useRef, useEffect } from "react";
import axios from 'axios';
import "../../../css/dashboard.css";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";

function StaffDetail(props) {

    const location = useLocation();
    const navigate = useNavigate();

    const [reserve, setReserve] = useState({});
    const [editData, setEditData] = useState({}); // ✅ [New] 수정 모달용 별도 상태
    const modalCorrective = useRef();

    const [adminPwInput, setAdminPwInput] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [resetStep, setResetStep] = useState(0); // 0: 관리자 인증, 1: 새 비밀번호 입력
    const adminPwDialogRef = useRef();

    const startBeforePage = () => {
        if (location.state && location.state.beforePage) {
            navigate(location.state.beforePage);
        } else {
            navigate(-1);
        }
    }

    const startModal = () => {
        setEditData({ ...reserve }); // ✅ [New] 모달 열 때 현재 데이터를 editData로 복사
        modalCorrective.current.showModal();
    }

    const ChangeId = (e) => {
        let input = e.target.value.replace(/[^a-zA-Z0-9\s]/g, ''); // 영어와 숫자 허용
        setEditData({ ...editData, id: input });
    }
    const ChangePw = (e) => {
        setEditData({ ...editData, pw: e.target.value });
    }
    const ChangeName = (e) => {
        setEditData({ ...editData, name: e.target.value });
    }
    const ChangeEnName = (e) => {
        let input = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // 영어와 공백만 허용
        setEditData({ ...editData, english_name: input });
    }
    const ChangePhoneNum = (e) => {
        let input = e.target.value.replace(/[^0-9]/g, ''); // 숫자가 아닌 모든 문자 제거
        if (input.length > 11) input = input.slice(0, 11);
        if (input.length < 4) {
            input = input;
        } else if (input.length < 8) {
            input = input.slice(0, 3) + '-' + input.slice(3);
        } else {
            input = input.slice(0, 3) + '-' + input.slice(3, 7) + '-' + input.slice(7);
        }
        setEditData({ ...editData, phone_num: input });
    }
    const ChangeRank = (e) => {
        setEditData({ ...editData, rank: e.target.value });
    }
    const ChangeAddress = (e) => {
        setEditData({ ...editData, address: e.target.value });
    }
    const ChangeResident = (e) => {
        let input = e.target.value.replace(/\D/g, ''); // 숫자만 허용
        if (input.length > 6) input = input.slice(0, 6) + '-' + input.slice(6, 13);
        if (input.length > 14) input = input.slice(0, 14);
        setEditData({ ...editData, resident_number: input });
    }
    const ChangeDate = (e) => {
        setEditData({ ...editData, regist_date: e.target.value });
    }
    const ChangeAffliation = (e) => {
        setEditData({ ...editData, affili: e.target.value });
    }
    const ChangeMemo = (e) => {
        setEditData({ ...editData, memo: e.target.value });
    }

    // 권한 토글 핸들러
    const togglePermission = (key) => {
        const currentPermissions = editData.permissions ? (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions) : editData.permissions) : {};
        const newPermissions = { ...currentPermissions, [key]: !currentPermissions[key] };
        setEditData({ ...editData, permissions: JSON.stringify(newPermissions) });
    };

    const putStaffInfo = async () => {
        const requestData = {
            id: editData.id,
            pw: editData.pw,
            name: editData.name,
            english_name: editData.english_name,
            phone_num: editData.phone_num,
            address: editData.address,
            resident_number: editData.resident_number,
            regist_date: editData.regist_date,
            rank: editData.rank,
            affili: editData.affili,
            memo: editData.memo || '',
            permissions: editData.permissions ? (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions) : editData.permissions) : {}
        };
        try {
            const put_result = await axios.put(`/StaffRegist/${location.state.idx}`, requestData);
            if (put_result.data.success === true) {
                alert('수정이 완료되었습니다');
                setReserve(editData); // ✅ [New] 성공 시 뷰 데이터 업데이트
                modalCorrective.current.close();
            } else {
                alert('수정에 실패하였습니다');
            }
        } catch (error) {
            console.error('Error :', error.message);
        }
    };

    useEffect(() => {
        const getReservationDetail = async () => {
            try {
                const reserve_result = await axios.get(`/StaffRegistId/${location.state.idx}`);
                setReserve(reserve_result.data[0]);
            } catch (error) {
                console.error('Error fetching reservation count:', error.message);
            }
        };
        getReservationDetail();
    }, [location.state.idx]);

    // ✅ [Added] 직원 탈퇴 핸들러
    const handleWithdraw = async () => {
        if (window.confirm("정말로 탈퇴 처리하시겠습니까? 이 작업은 되돌릴 수 없습니다.")) {
            try {
                const response = await axios.delete(`/StaffRegist/${reserve.id}`);
                if (response.data.success) {
                    alert('직원 탈퇴 처리가 완료되었습니다.');
                    modalCorrective.current.close();
                    navigate(-1); // 목록으로 돌아가기
                } else {
                    alert('탈퇴 처리에 실패했습니다.');
                }
            } catch (error) {
                console.error('Error withdrawing staff:', error);
                alert('탈퇴 처리 중 오류가 발생했습니다.');
            }
        }
    };

    const closeAdminPwDialog = () => {
        setAdminPwInput('');
        setNewPassword('');
        setResetStep(0);
        adminPwDialogRef.current.close();
    };

    const handleVerifyAdminPw = async () => {
        const loginId = localStorage.getItem('loginId');
        try {
            const result = await axios.post('/api/auth/login', { id: loginId, pw: adminPwInput });
            if (result.data.success) {
                setResetStep(1);
                setAdminPwInput('');
            } else {
                alert('비밀번호가 일치하지 않습니다.');
            }
        } catch (error) {
            alert('비밀번호 확인 중 오류가 발생했습니다.');
        }
    };

    const handleResetPassword = async () => {
        if (!newPassword || newPassword.length < 4) {
            alert('비밀번호는 4자 이상 입력해주세요.');
            return;
        }
        try {
            const result = await axios.put(`/StaffRegist/${location.state.idx}`, { pw: newPassword });
            if (result.data.success) {
                alert('비밀번호가 초기화되었습니다.');
                closeAdminPwDialog();
            } else {
                alert('비밀번호 초기화에 실패했습니다.');
            }
        } catch (error) {
            alert('비밀번호 초기화 중 오류가 발생했습니다.');
        }
    };

    return (
        <PageContainer>
            <Card>
                <CardHeader>
                    <Title>직원 상세 정보</Title>
                </CardHeader>

                <SectionTitle>계정 및 인적사항</SectionTitle>
                <GridContainer>
                    <InfoItem label="아이디" value={reserve.id} />
                    <div style={{ gridColumn: 'span 1', display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <Label>비밀번호</Label>
                        <PasswordRow>
                            <Value>●●●●●●</Value>
                            <SmallButton onClick={() => adminPwDialogRef.current.showModal()}>
                                초기화
                            </SmallButton>
                        </PasswordRow>
                    </div>
                    <InfoItem label="이름" value={reserve.name} />
                    <InfoItem label="영문이름" value={reserve.english_name} />
                    <InfoItem label="연락처" value={reserve.phone_num} />
                    <InfoItem label="주민등록번호" value={reserve.resident_number} />
                    <InfoItem label="주소" value={reserve.address} span={2} />
                </GridContainer>

                <SectionTitle>근무 정보</SectionTitle>
                <GridContainer>
                    <InfoItem label="입사일" value={reserve.regist_date} />
                    <InfoItem label="직책" value={reserve.rank} isHighlight />
                    <InfoItem label="소속" value={reserve.affili} span={2} />
                </GridContainer>

                <SectionTitle>메모</SectionTitle>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    <Label>관리자 메모</Label>
                    <ReadOnlyTextArea>
                        {reserve.memo || '등록된 메모가 없습니다.'}
                    </ReadOnlyTextArea>
                </div>

                <SectionTitle>접근 권한</SectionTitle>
                <GridContainer>
                    <PermissionItem label="고객 관리" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).user_manage} />
                    <PermissionItem label="고객 탈퇴 현황" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).user_leave_manage} />
                    <PermissionItem label="매니저 관리" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).manager_manage} />
                    <PermissionItem label="매니저 가입 요청" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).manager_request_manage} />
                    <PermissionItem label="요금 관리" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).cost_manage} />
                    <PermissionItem label="교육 관리" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).training_manage} />
                    <PermissionItem label="팝업 관리" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).popup_manage} />
                    <PermissionItem label="앱 버전 관리" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).app_version_manage} />
                    <PermissionItem label="가입 혜택 관리" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).benefit_event_manage} />
                    <PermissionItem label="변경 이력" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).action_log_view} />
                    <PermissionItem label="쿠폰 관리" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).coupon_manage} />
                    <PermissionItem label="정산 관리" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).bilings} />
                    <PermissionItem label="대량주문 문의내역" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).bulk_order_manage} />
                    <PermissionItem label="견적서" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).quotation_manage} />
                    <PermissionItem label="전체 예약 관리" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).total_reservation_manage} />
                    <PermissionItem label="금일 예약 요청" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).today_reservation_manage} />
                    <PermissionItem label="예약 요청 미처리건" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).unprocessed_reservation_manage} />
                    <PermissionItem label="A/S" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).as_manage} />
                    <PermissionItem label="유저 공지" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).user_notice_manage} />
                    <PermissionItem label="유저 이벤트" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).user_event_manage} />
                    <PermissionItem label="매니저 공지" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).manager_notice_manage} />
                    <PermissionItem label="매니저 이벤트" hasPermission={reserve.permissions && JSON.parse(reserve.permissions).manager_event_manage} />
                </GridContainer>

                <ButtonGroup>
                    <div style={{ marginRight: 'auto' }}>
                        <OutlineButton onClick={handleWithdraw} style={{ borderColor: '#dc3545', color: '#dc3545' }}>탈퇴</OutlineButton>
                    </div>
                    <OutlineButton onClick={startBeforePage}>목록으로</OutlineButton>
                    <PrimaryButton onClick={startModal}>수정하기</PrimaryButton>
                </ButtonGroup>
            </Card>

            {/* 수정 모달 */}
            <StyledDialog ref={modalCorrective}>
                <DialogHeader>
                    <h3>직원 정보 수정</h3>
                    <CloseButton onClick={() => modalCorrective.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    <SectionTitle>기본 정보</SectionTitle>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
                        <InputGroup label="아이디" value={editData.id} onChange={ChangeId} />
                        <InputGroup label="비밀번호" type="password" value={editData.pw} onChange={ChangePw} />
                        <InputGroup label="이름" value={editData.name} onChange={ChangeName} />
                        <InputGroup label="영문이름" value={editData.english_name} onChange={ChangeEnName} />
                        <InputGroup label="연락처" value={editData.phone_num} onChange={ChangePhoneNum} />
                        <InputGroup label="주민등록번호" value={editData.resident_number} onChange={ChangeResident} />
                    </div>
                    <InputGroup label="주소" value={editData.address} onChange={ChangeAddress} />

                    <SectionTitle>근무 정보</SectionTitle>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px' }}>
                        <InputGroup label="입사일" type="date" value={editData.regist_date} onChange={ChangeDate} />
                        <InputGroup label="소속" value={editData.affili} onChange={ChangeAffliation} />
                        <div>
                            <Label>직책</Label>
                            <StyledSelect value={editData.rank} onChange={ChangeRank}>
                                <option value="사원">사원</option>
                                <option value="주임">주임</option>
                                <option value="대리">대리</option>
                                <option value="과장">과장</option>
                                <option value="팀장">팀장</option>
                                <option value="차장">차장</option>
                                <option value="부장">부장</option>
                                <option value="이사">이사</option>
                            </StyledSelect>
                        </div>
                    </div>

                    <SectionTitle style={{ marginTop: '20px' }}>메모</SectionTitle>
                    <div>
                        <Label>관리자 메모</Label>
                        <StyledTextarea value={editData.memo || ''} onChange={ChangeMemo} placeholder="직원에 대한 메모를 입력하세요..." rows={4} />
                    </div>

                    <SectionTitle style={{ marginTop: '20px' }}>접근 권한 설정</SectionTitle>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px' }}>
                        <ToggleItem label="고객 관리" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).user_manage : editData.permissions.user_manage)} onChange={() => togglePermission('user_manage')} />
                        <ToggleItem label="고객 탈퇴 현황" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).user_leave_manage : editData.permissions.user_leave_manage)} onChange={() => togglePermission('user_leave_manage')} />
                        <ToggleItem label="매니저 관리" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).manager_manage : editData.permissions.manager_manage)} onChange={() => togglePermission('manager_manage')} />
                        <ToggleItem label="매니저 가입 요청" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).manager_request_manage : editData.permissions.manager_request_manage)} onChange={() => togglePermission('manager_request_manage')} />
                        <ToggleItem label="요금 관리" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).cost_manage : editData.permissions.cost_manage)} onChange={() => togglePermission('cost_manage')} />
                        <ToggleItem label="교육 관리" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).training_manage : editData.permissions.training_manage)} onChange={() => togglePermission('training_manage')} />
                        <ToggleItem label="팝업 관리" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).popup_manage : editData.permissions.popup_manage)} onChange={() => togglePermission('popup_manage')} />
                        <ToggleItem label="앱 버전 관리" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).app_version_manage : editData.permissions.app_version_manage)} onChange={() => togglePermission('app_version_manage')} />
                        <ToggleItem label="가입 혜택 관리" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).benefit_event_manage : editData.permissions.benefit_event_manage)} onChange={() => togglePermission('benefit_event_manage')} />
                        <ToggleItem label="변경 이력" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).action_log_view : editData.permissions.action_log_view)} onChange={() => togglePermission('action_log_view')} />
                        <ToggleItem label="쿠폰 관리" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).coupon_manage : editData.permissions.coupon_manage)} onChange={() => togglePermission('coupon_manage')} />
                        <ToggleItem label="정산 관리" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).bilings : editData.permissions.bilings)} onChange={() => togglePermission('bilings')} />
                        <ToggleItem label="대량주문 문의내역" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).bulk_order_manage : editData.permissions.bulk_order_manage)} onChange={() => togglePermission('bulk_order_manage')} />
                        <ToggleItem label="견적서" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).quotation_manage : editData.permissions.quotation_manage)} onChange={() => togglePermission('quotation_manage')} />
                        <ToggleItem label="전체 예약 관리" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).total_reservation_manage : editData.permissions.total_reservation_manage)} onChange={() => togglePermission('total_reservation_manage')} />
                        <ToggleItem label="금일 예약 요청" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).today_reservation_manage : editData.permissions.today_reservation_manage)} onChange={() => togglePermission('today_reservation_manage')} />
                        <ToggleItem label="예약 요청 미처리건" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).unprocessed_reservation_manage : editData.permissions.unprocessed_reservation_manage)} onChange={() => togglePermission('unprocessed_reservation_manage')} />
                        <ToggleItem label="A/S" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).as_manage : editData.permissions.as_manage)} onChange={() => togglePermission('as_manage')} />
                        <ToggleItem label="유저 공지" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).user_notice_manage : editData.permissions.user_notice_manage)} onChange={() => togglePermission('user_notice_manage')} />
                        <ToggleItem label="유저 이벤트" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).user_event_manage : editData.permissions.user_event_manage)} onChange={() => togglePermission('user_event_manage')} />
                        <ToggleItem label="매니저 공지" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).manager_notice_manage : editData.permissions.manager_notice_manage)} onChange={() => togglePermission('manager_notice_manage')} />
                        <ToggleItem label="매니저 이벤트" checked={editData.permissions && (typeof editData.permissions === 'string' ? JSON.parse(editData.permissions).manager_event_manage : editData.permissions.manager_event_manage)} onChange={() => togglePermission('manager_event_manage')} />
                    </div>
                </DialogContent>
                <DialogActions>
                    <OutlineButton onClick={() => modalCorrective.current.close()}>취소</OutlineButton>
                    <PrimaryButton onClick={putStaffInfo}>저장하기</PrimaryButton>
                </DialogActions>
            </StyledDialog>

            {/* 관리자 비밀번호 확인 다이얼로그 */}
            <StyledDialog ref={adminPwDialogRef}>
                <DialogHeader>
                    <h3>{resetStep === 0 ? '관리자 비밀번호 확인' : '새 비밀번호 설정'}</h3>
                    <CloseButton onClick={closeAdminPwDialog}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    {resetStep === 0 ? (
                        <InputGroup label="관리자 비밀번호" type="password" value={adminPwInput} onChange={(e) => setAdminPwInput(e.target.value)} />
                    ) : (
                        <InputGroup label="새 비밀번호" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                    )}
                </DialogContent>
                <DialogActions>
                    <OutlineButton onClick={closeAdminPwDialog}>취소</OutlineButton>
                    {resetStep === 0 ? (
                        <PrimaryButton onClick={handleVerifyAdminPw}>확인</PrimaryButton>
                    ) : (
                        <PrimaryButton onClick={handleResetPassword}>초기화</PrimaryButton>
                    )}
                </DialogActions>
            </StyledDialog>
        </PageContainer>
    )
}

// --- Helper Components ---
const InfoItem = ({ label, value, span = 1, isHighlight }) => (
    <div style={{ gridColumn: `span ${span}`, display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <Label>{label}</Label>
        <Value isHighlight={isHighlight}>{value || '-'}</Value>
    </div>
);

const PermissionItem = ({ label, hasPermission }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <Label>{label}</Label>
        <Value style={{ color: hasPermission ? '#006edc' : '#999', fontWeight: hasPermission ? 'bold' : 'normal' }}>
            {hasPermission ? '허용됨' : '차단됨'}
        </Value>
    </div>
);

const ToggleItem = ({ label, checked, onChange }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px', border: '1px solid #eee', borderRadius: '8px' }}>
        <span style={{ fontSize: '0.9rem', fontWeight: '500', color: '#333' }}>{label}</span>
        <SwitchLabel>
            <input type="checkbox" checked={!!checked} onChange={onChange} />
            <Slider />
        </SwitchLabel>
    </div>
);

const InputGroup = ({ label, value, onChange, type = "text" }) => (
    <div>
        <Label>{label}</Label>
        <StyledInput type={type} value={value || ''} onChange={onChange} />
    </div>
);

// --- Styled Components (80% Compact Version) ---

const PageContainer = styled.div`
    padding: 20px;
    background-color: #f5f6f8;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 40px;
    box-sizing: border-box;
`;

const Card = styled.div`
    background: white;
    width: 100%;
    max-width: 1000px;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    padding: 32px 36px;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const CardHeader = styled.div`
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;
    margin-bottom: 8px;
`;

const Title = styled.h2`
    font-size: 1.5rem;
    color: #111;
    margin: 0;
    font-weight: 800;
`;

const SectionTitle = styled.h3`
    font-size: 1.1rem;
    color: #333;
    margin: 20px 0 10px 0;
    border-left: 4px solid #006edc;
    padding-left: 10px;
`;

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 20px;
    row-gap: 16px;
    @media (max-width: 768px) { grid-template-columns: repeat(2, 1fr); }
`;

const Label = styled.div`
    font-size: 0.8rem;
    color: #888;
    font-weight: 500;
    margin-bottom: 3px;
`;

const Value = styled.div`
    font-size: 0.95rem;
    color: ${props => props.isHighlight ? '#d32f2f' : '#222'};
    font-weight: ${props => props.isHighlight ? 'bold' : 'normal'};
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 5px;
    min-height: 22px;
    word-break: break-all;
`;

const PasswordRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const SmallButton = styled.button`
    padding: 2px 8px;
    font-size: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #f5f5f5;
    cursor: pointer;
    color: #666;
    white-space: nowrap;
    flex-shrink: 0;
    &:hover { background: #eee; }
`;

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eee;
`;

const BaseButton = styled.button`
    padding: 8px 18px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    font-size: 0.9rem;
`;

const PrimaryButton = styled(BaseButton)`
    background-color: #006edc;
    color: white;
    &:hover { background-color: #0056b3; }
`;

const OutlineButton = styled(BaseButton)`
    background-color: white;
    border: 1px solid #ccc;
    color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;

// Styled Input & Select
const StyledInput = styled.input`
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.95rem;
    box-sizing: border-box;
    &:focus { border-color: #006edc; outline: none; }
`;

const StyledTextarea = styled.textarea`
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.95rem;
    box-sizing: border-box;
    font-family: inherit;
    resize: vertical;
    &:focus { border-color: #006edc; outline: none; }
`;

const ReadOnlyTextArea = styled.div`
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    font-size: 0.95rem;
    line-height: 1.6;
    color: #333;
    white-space: pre-wrap;
    min-height: 100px;
    max-height: 300px;
    overflow-y: auto;
`;

const StyledSelect = styled.select`
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.95rem;
    box-sizing: border-box;
    background-color: white;
    &:focus { border-color: #006edc; outline: none; }
`;

// --- Modal Styles ---
const StyledDialog = styled.dialog`
    border: none;
    border-radius: 16px;
    padding: 0;
    width: 90%;
    max-width: 800px;
    box-shadow: 0 10px 40px rgba(0,0,0,0.25);
    &::backdrop { background: rgba(0, 0, 0, 0.6); }
`;

const DialogHeader = styled.div`
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h3 { margin: 0; font-size: 1.2rem; font-weight: 700; }
`;

const DialogContent = styled.div`
    padding: 24px;
    background: #fff;
    max-height: 80vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`;

const DialogActions = styled.div`
    padding: 16px 20px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

const CloseButton = styled.button`
    background: none; border: none; font-size: 1.8rem; cursor: pointer; color: #999; line-height: 1;
    &:hover { color: #333; }
`;

const SwitchLabel = styled.label`
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    
    input { 
        opacity: 0;
        width: 0;
        height: 0;
    }
`;

const Slider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;

    &:before {
        position: absolute;
        content: "";
        height: 16px;
        width: 16px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        transition: .4s;
        border-radius: 50%;
    }

    input:checked + & {
        background-color: #006edc;
    }

    input:checked + &:before {
        transform: translateX(20px);
    }
`;

export default StaffDetail;
